import { render, staticRenderFns } from "./AttrEntityMenu.vue?vue&type=template&id=a61c9b0e"
import script from "./AttrEntityMenu.vue?vue&type=script&lang=js"
export * from "./AttrEntityMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports